<template>
	<div class="container-payments" >
		<h5 class="text-center text-bold">
			Tarjetas de Crédito
		</h5>
		<br>
		<b-button block squared variant="outline-success" class="my-2 my-sm-0" type="button" @click="$bvModal.show('modal-add-card')">Agregar Tarjeta</b-button>
		<b-overlay rounded="lg" spinner-variant="gold">
			<b-row style="width: 100%;" class="content-card">
				<b-col>
					<b-table-simple condensed borderless hover>
						<tbody>
							<b-tr class="d-none d-lg-table-row">
								<b-th>Fecha</b-th>
								<b-th>Tipo</b-th>
								<b-th>Numero de tarjeta</b-th>
								<b-th v-if="can_change_asset">Bienes</b-th>
								<b-th>Por Defecto</b-th>
								<b-th>Eliminar</b-th>
							</b-tr>
							<template  v-for="(card, key) in cards">
								<b-tr :key="'pay-tr'+key"  class="d-none d-lg-table-row">
									<b-td>
										{{card.created_at | moment("DD-MM-YYYY")}}
									</b-td>
									<b-td v-if="card.card_type">
										<font-awesome-icon :icon="set_icon_card(card.card_type)" size="lg" />
									</b-td>
									<b-td v-if="card.card_number">
										XXXX-XXXX-XXXX-{{card.card_number.substr(card.card_number.length - 4)}}
									</b-td>
									<b-td v-if="can_change_asset">
										<b-button block squared variant="outline-gold" class="my-2 my-sm-0" type="button" @click="open_modal(card)">Agregar Bienes</b-button>
									</b-td>
									<b-td v-if="card.default">
                                        <center>Tarjeta Principal</center>									</b-td>
									<b-td v-else>
										<b-button @click="set_default_card(card, key)" block squared variant="outline-gold" class="my-2 my-sm-0" type="button" >Activar Principal</b-button>
									</b-td>
									<b-td>
										<b-button @click="delete_card(card, key)" block squared variant="outline-danger" class="my-2 my-sm-0" type="button" >Eliminar</b-button>
									</b-td>
								</b-tr>
							</template>
						</tbody>
					</b-table-simple>
				</b-col>
			</b-row>
		</b-overlay>
		<b-modal id="modal-add-card" hide-footer>
			<template #modal-title>
				Agregar Tarjeta de Crédito
			</template>
			<div class="d-block text-center">
				lorem ipsum
			</div>
			<b-button @click="add_card()" block squared variant="outline-success" class="my-2 my-sm-0" type="button" target="_blank">Acepto Términos y Condiciones</b-button>
		</b-modal>
		<b-modal id="modal-asset-card" hide-footer>
			<template #modal-title>
				Agregar Bien
			</template>
			<b-table-simple>				
				<b-tr v-for="(apartment, asset_id) in this.$store.state.apartments" :key="asset_id">
					<b-td>
						- {{apartment.asset_type}} {{apartment.number}}
					</b-td>
					<b-td v-if="set_button_add_asset(apartment.asset_id)">
						<b-button @click="set_asset_card(apartment.asset_id)" block squared variant="outline-success" class="my-2 my-sm-0" type="button" target="_blank">Agregar</b-button>
					</b-td>
					<b-td v-else>
						<b-button @click="delete_asset_card(apartment.asset_id)" block squared variant="outline-danger" class="my-2 my-sm-0" type="button" target="_blank">Borrar</b-button>
					</b-td>
				</b-tr>
			</b-table-simple>
		</b-modal>
		<form id="webpay-form" ref="form" action="https://webpay3gint.transbank.cl/webpayserver/bp_multicode_inscription.cgi" accept-charset="UTF-8" method="post">
			<input id="webpay-token" type="hidden" name="TBK_TOKEN" v-model="transbank.token">
		</form>
	</div>
</template>
<script>
	export default {
		name: "payments",
		components: {
		},
		props: {
			asset_id: null
		},
		data() {
			return {
				current_card_asset: {assets: []},
				customStyles: {
					li: {
						display: 'inline-block',
					},
					a: {
						color: 'black'
					}
				},
				customLabels: {
					first: '<<',
					last: '>>',
					previous: '<',
					next: '>'
				},
				transbank: {
					token: "",
					url: "",
					monto: "",
					concept: "",
					back_url: window.location.href,
					id: "",
					loading: false
				},
				pageOfItems: [],
				loading: true,
			}
		},
		computed: {
			cards(){
				return this.$store.getters.getCards
			},
			can_change_asset(){
				return this.$store.state.apartments.length > 1
			}
		},
		methods: {
			delete_asset_card(asset_id){
				this.$swal({
					title: '¿Estás seguro que deseas borrar este bien a esta tarjeta?',
					text: "Se dejarán de realizaran cobros de este bien a esta tarjeta",
					icon: 'warning',
					showCancelButton: true,
					cancelButtonText: "Cancelar",
					confirmButtonColor: '#5cb85c',
					cancelButtonColor: '#3085d6',
					confirmButtonText: 'Confirmar'
				}).then((result) => {
					if (result.isConfirmed) {
						this.axios.post("payments/oneclick/delete_asset_card", {asset_id: asset_id, card_id: this.current_card_asset.card_id}).then(() => {
							this.current_card_asset.assets = this.current_card_asset.assets.filter(element => element != asset_id);
							this.$swal('¡Éxito!', 'Bien borrado con éxito', 'success')
						}).catch(() => {
							this.$swal('¡Parece que hubo un error!', '', 'info')
						})
					}
				})
			},
			set_button_add_asset(asset_id){
				let is_in = this.current_card_asset.assets.filter(element => element == asset_id);
				return is_in.length == 0
			},
			set_asset_card(asset_id){
				this.$swal({
					title: '¿Estás seguro que deseas agregar este bien a esta tarjeta?',
					text: "Se realizaran cobros de este bien a esta tarjeta",
					icon: 'warning',
					showCancelButton: true,
					cancelButtonText: "Cancelar",
					confirmButtonColor: '#5cb85c',
					cancelButtonColor: '#3085d6',
					confirmButtonText: 'Confirmar'
				}).then((result) => {
					if (result.isConfirmed) {
						this.axios.post("payments/oneclick/add_card_asset", {asset_id: asset_id, card_id: this.current_card_asset.card_id}).then(() => {
							this.current_card_asset.assets.push(asset_id)
							this.$swal('¡Éxito!', 'Bien agregado con éxito', 'success')
						}).catch(() => {
							this.$swal('¡Parece que hubo un error!', '', 'info')
						})
					}
				})
			},
			open_modal(card){
				this.current_card_asset = card
				this.$bvModal.show('modal-asset-card')	
			},
			set_default_card(card){
				this.$swal({
					title: '¿Estás seguro que deseas agregar esta tarjeta como principal?',
					text: "Todos los cobros se harán a esta tarjeta",
					icon: 'warning',
					showCancelButton: true,
					cancelButtonText: "Cancelar",
					confirmButtonColor: '#5cb85c',
					cancelButtonColor: '#3085d6',
					confirmButtonText: 'Confirmar'
				}).then((result) => {
					if (result.isConfirmed) {
						this.axios.post("payments/oneclick/set_default", {id: card.card_id}).then(() => {
							this.cards.forEach(card => card.default = false);
							card.default = true
							this.$swal('¡Éxito!', 'Tarjeta agregada con éxito', 'success')
						}).catch(() => {
							this.$swal('¡Parece que hubo un error!', '', 'info')
						})
					}
				})
			},
			set_icon_card(icon_card){
				if(icon_card == "RedCompra"){
					return ['fas', 'credit-card']
				}else{
					return ['fab', 'cc-'+icon_card.toLowerCase()]
				}
			},
			get_cards(){
				this.axios.get("payments/oneclick").then(result => {						
					this.cards = result.data
					this.loading = false
				})
			},
			add_card(){
                this.axios.post("payments/oneclick/add_card", {return_path: "", assets: this.$store.state.apartments}).then(result => {
					this.transbank.token = result.data.token
					this.transbank.url = result.data.url_webpay
					this.transbank.loading = false
					if(this.transbank.token)
						document.getElementById("webpay-token").value = result.data.token;
						document.getElementById("webpay-form").submit();
				}).catch(() => {
					this.$swal('¡Parece que hubo un error!', '', 'info')
					this.transbank.loading = false
				})
			},
			delete_card(card, key){
				this.$swal({
						title: '¿Estás seguro que deseas borrar esta tarjeta?',
						text: "Si es tu ultima tarjeta no se cobrará de forma automática tus pagos",
						icon: 'warning',
						showCancelButton: true,
						cancelButtonText: "Cancelar",
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Borrar'
					}).then(() => {
						this.axios.delete(`payments/oneclick/${card.card_id}`).then(() => {
							this.cards.splice(key, 1)
							this.$swal('¡Éxito!', 'Tarjeta borrada con éxito', 'success')
						}).catch(() => {
							this.$swal('¡Parece que hubo un error!', '', 'info')
						})
					})
			},
			onChangePage(pageOfItems) {
				this.pageOfItems = pageOfItems;
			},
			showModal(payment) {
				this.$refs['my-modal'].show()
				this.transbank.id = payment.codigo
				this.transbank.monto = parseInt(payment.montoPago * payment.valorUF)
			},
			is_payed(payment){
				if(payment.reciboPago === undefined){
					return false
				}else{
					return true
				}
			}
		}
	};
</script>
<style>
</style>